var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilFill = function SvgPencilFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.675 6.143 3.181 3.183-7.425 7.424H3.25v-3.182zm1.06-1.06 1.591-1.592a.75.75 0 0 1 1.06 0l2.123 2.122a.75.75 0 0 1 0 1.06l-1.592 1.591-3.181-3.181Z"
  })));
};
export default SvgPencilFill;